var map = {
	"./acessos-teste/acessos.module": [
		"./src/app/acessos-teste/acessos.module.ts",
		"default~acessos-teste-acessos-module~analytics-news-analytics-news-module~certificado-certificado-mo~f840f3f0",
		"acessos-teste-acessos-module"
	],
	"./analytics-news/analytics-news.module": [
		"./src/app/analytics-news/analytics-news.module.ts",
		"default~acessos-teste-acessos-module~analytics-news-analytics-news-module~certificado-certificado-mo~f840f3f0",
		"analytics-news-analytics-news-module"
	],
	"./assessment/assessment.module": [
		"./src/app/assessment/assessment.module.ts",
		"common",
		"assessment-assessment-module"
	],
	"./avaliation/avaliation.module": [
		"./src/app/avaliation/avaliation.module.ts",
		"default~avaliation-avaliation-module~comments-comments-module~courses-courses-module~journeys-journeys-module",
		"avaliation-avaliation-module"
	],
	"./banners/banners.module": [
		"./src/app/banners/banners.module.ts",
		"banners-banners-module"
	],
	"./comments/comments.module": [
		"./src/app/comments/comments.module.ts",
		"default~avaliation-avaliation-module~comments-comments-module~courses-courses-module~journeys-journeys-module"
	],
	"./courses-news/courses-news.module": [
		"./src/app/courses-news/courses-news.module.ts",
		"default~acessos-teste-acessos-module~analytics-news-analytics-news-module~certificado-certificado-mo~f840f3f0",
		"courses-news-courses-news-module"
	],
	"./courses/courses.module": [
		"./src/app/courses/courses.module.ts",
		"default~avaliation-avaliation-module~comments-comments-module~courses-courses-module~journeys-journeys-module",
		"courses-courses-module"
	],
	"./e-commerce/e-commerce.module": [
		"./src/app/e-commerce/e-commerce.module.ts",
		"e-commerce-e-commerce-module"
	],
	"./ead/ead.module": [
		"./src/app/ead/ead.module.ts",
		"ead-ead-module"
	],
	"./engagement-evolution-news/engagement-evolution-news.module": [
		"./src/app/engagement-evolution-news/engagement-evolution-news.module.ts",
		"default~acessos-teste-acessos-module~analytics-news-analytics-news-module~certificado-certificado-mo~f840f3f0",
		"engagement-evolution-news-engagement-evolution-news-module"
	],
	"./entries/entries.module": [
		"./src/app/entries/entries.module.ts",
		"common",
		"entries-entries-module"
	],
	"./events/events.module": [
		"./src/app/events/events.module.ts",
		"common",
		"events-events-module"
	],
	"./fast-courses-news/fast-courses-news.module": [
		"./src/app/fast-courses-news/fast-courses-news.module.ts",
		"default~acessos-teste-acessos-module~analytics-news-analytics-news-module~certificado-certificado-mo~f840f3f0",
		"fast-courses-news-fast-courses-news-module"
	],
	"./forum/forum.module": [
		"./src/app/forum/forum.module.ts",
		"forum-forum-module"
	],
	"./gamification/gamification.module": [
		"./src/app/gamification/gamification.module.ts",
		"common",
		"gamification-gamification-module"
	],
	"./journeys-news/journeys-news.module": [
		"./src/app/journeys-news/journeys-news.module.ts",
		"default~acessos-teste-acessos-module~analytics-news-analytics-news-module~certificado-certificado-mo~f840f3f0",
		"journeys-news-journeys-news-module"
	],
	"./journeys/journeys.module": [
		"./src/app/journeys/journeys.module.ts",
		"default~avaliation-avaliation-module~comments-comments-module~courses-courses-module~journeys-journeys-module",
		"journeys-journeys-module"
	],
	"./leader/leader.module": [
		"./src/app/leader/leader.module.ts",
		"leader-leader-module"
	],
	"./mentoring/mentoring.module": [
		"./src/app/mentoring/mentoring.module.ts",
		"mentoring-mentoring-module"
	],
	"./multi-contas/multi-contas.module": [
		"./src/app/multi-contas/multi-contas.module.ts",
		"common",
		"multi-contas-multi-contas-module"
	],
	"./news/news.module": [
		"./src/app/news/news.module.ts",
		"common",
		"news-news-module"
	],
	"./payment/payment.module": [
		"./src/app/payment/payment.module.ts",
		"payment-payment-module"
	],
	"./performance/performance.module": [
		"./src/app/performance/performance.module.ts",
		"performance-performance-module"
	],
	"./portal/portal.module": [
		"./src/app/portal/portal.module.ts",
		"default~portal-portal-module~users-users-module",
		"portal-portal-module"
	],
	"./profile/profile.module": [
		"./src/app/profile/profile.module.ts",
		"profile-profile-module"
	],
	"./required-courses-news/required-courses-news.module": [
		"./src/app/required-courses-news/required-courses-news.module.ts",
		"default~acessos-teste-acessos-module~analytics-news-analytics-news-module~certificado-certificado-mo~f840f3f0",
		"required-courses-news-required-courses-news-module"
	],
	"./suporte/suporte.module": [
		"./src/app/suporte/suporte.module.ts",
		"suporte-suporte-module"
	],
	"./users/users.module": [
		"./src/app/users/users.module.ts",
		"default~portal-portal-module~users-users-module"
	],
	"./videos/videos.module": [
		"./src/app/videos/videos.module.ts",
		"videos-videos-module"
	],
	"./whatsapp-interaction/whatsapp.module": [
		"./src/app/whatsapp-interaction/whatsapp.module.ts",
		"common",
		"whatsapp-interaction-whatsapp-module"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;